import '../DataCollectionGroupPanel.css'

import { Table, tbody, td, tr } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'
import { multiply } from '../../../../helpers/NumericTransformationsHelper.js'

export default class FiveSectionPanel extends React.Component {
  getRow(key, value) {
    return (
      <tr>
        <td xs={5} md={5} className="parameterKey">
          {key}
        </td>
        <td xs={7} md={7} className="parameterValue">
          {value}
        </td>
      </tr>
    )
  }

  render() {
    return (
      <Table>
        <tbody>
          {this.getRow('Focusing optics', this.props.datacollectiongroup.focusingOptic)}
          {this.getRow('Monochromator type', this.props.datacollectiongroup.MonochromatorType)}
          {this.getRow('Beam shape', this.props.datacollectiongroup.beamShape)}
          {this.getRow(
            'Beam size at Sample Hor (Vert)',
            multiply(this.props.datacollectiongroup.beamSizeAtSampleX, 1000) +
              '(' +
              multiply(this.props.datacollectiongroup.beamSizeAtSampleY, 1000) +
              ') μm'
          )}
          {this.getRow(
            'Beam divergence Hor (Vert)',
            this.props.datacollectiongroup.beamDivergenceHorizontal +
              '(' +
              this.props.datacollectiongroup.beamDivergenceVertical +
              ')  μrad'
          )}
          {this.getRow('Polarisation', this.props.datacollectiongroup.polarisation)}
        </tbody>
      </Table>
    )
  }
}
FiveSectionPanel.propTypes = {
  focusingOptic: PropTypes.string,
  MonochromatorType: PropTypes.string,
  beamShape: PropTypes.string,
  beamSizeAtSampleX: PropTypes.string,
  beamSizeAtSampleY: PropTypes.string,
  beamDivergenceHorizontal: PropTypes.string,
  beamDivergenceVertical: PropTypes.string,
  polarisation: PropTypes.string,
}
